import SideBar from "@components/sidebar/sidebar";
import Layout from "@components/layout/layout";
import LandingVideoCard from "@components/landing-page/landing-video-card";
import StickyBox from "react-sticky-box";
import { useRouter } from "next/router";
import {
  useVideosIndexPageQuery,
  VideosIndexPageQuery,
} from "@graphql/generated/graphql";
import { Trans } from "@lingui/macro";
import { InfiniteList } from "@components/core/infinite-list";
import { CompactVideoCard } from "./video-card";

const AllVideosPage: React.FunctionComponent = () => {
  const { locale } = useRouter();

  const { data, loading, fetchMore, error } = useVideosIndexPageQuery({
    variables: {
      limit: 20,
      languageCodes: [locale],
      languageCode: locale,
    },
  });

  return (
    <Layout
      showNewsStacks={true}
      showCTA={false}
      showFooter={false}
      className="!overflow-visible"
      retainWholePage={true}
    >
      <div className="mx-auto my-6 flex max-w-7xl flex-row items-start px-4 2xs:px-6 lg:space-x-20">
        <section className="w-full flex-1 divide-y">
          {loading || error ? (
            <div className="py-64 text-center font-sen text-text-lightest">
              <Trans>Loading...</Trans>
            </div>
          ) : (
            <>
              <div className="mb-8">
                <LandingVideoCard
                  video={data.featuredVideo}
                  showLandingBig={true}
                />
              </div>
              <div className="mb-8 pt-6">
                <h3 className="pb-4 font-poppins text-xl font-bold text-text-darkest">
                  <Trans>Latest Videos</Trans>
                </h3>
                <InfiniteList
                  infiniteLoadingOption={{
                    dataLength: data.allVideos.length || 0,
                    next: () => {
                      fetchMore({
                        variables: {
                          limit: 20,
                          offset: data.allVideos.length,
                          languageCodes: [locale],
                        },
                      });
                    },
                    loader: (
                      <p className="py-4 text-center font-sen text-text-lightest">
                        <Trans>Loading...</Trans>
                      </p>
                    ),
                  }}
                >
                  <VideoList videos={data.allVideos} />
                </InfiniteList>
              </div>
            </>
          )}
        </section>

        <StickyBox offsetTop={20} offsetBottom={20}>
          <SideBar />
        </StickyBox>
      </div>
    </Layout>
  );
};

interface IVideoListProps {
  videos: VideosIndexPageQuery["allVideos"];
}

export const VideoList: React.FunctionComponent<IVideoListProps> = ({
  videos,
}) => {
  return (
    <div className="flex flex-row flex-wrap items-stretch">
      {videos.map((video) => (
        <div key={video.id} className="basis-full md:basis-1/3 md:pr-3 md:pb-6">
          <CompactVideoCard video={video} />
        </div>
      ))}
    </div>
  );
};

export default AllVideosPage;
